import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  BulkPatchProductPricingPayloadType,
  PatchProductPricingPayloadType,
  PayloadGetProductPricingByPageType,
  PayloadGetSingleProductPricingType,
  ProductPricingContent,
  ProductPricingState,
  SelectedProductPayload,
} from '../types/productPricing.types'

const initialState: ProductPricingState = {
  content: [],
  selected: null,
  totalPages: null,
  selectedProduct: null,
}

const ProductPricingSlice = createSlice({
  name: 'ProductPricing',
  initialState: initialState,
  reducers: {
    updateProductPricingData: (
      state: ProductPricingState,
      action: PayloadAction<ProductPricingContent[] | null>
    ) => {
      state.content = action.payload
    },
    updateSelectedProductPricing: (
      state: ProductPricingState,
      action: PayloadAction<ProductPricingContent | null>
    ) => {
      state.selected = action.payload
    },
    updateProductPricingByPage: (state: ProductPricingState, action) => {
      if (action?.payload.data) {
        state.content = action?.payload?.data?.content
        state.totalPages = action?.payload?.data?.totalPages
      }
    },
    getAllProductPricingByPageAction: (
      state: ProductPricingState,
      _action: PayloadAction<PayloadGetProductPricingByPageType>
    ) => {
      return state;
    },
    getSingleProductPricingAction: (
      state: ProductPricingState,
      _action: PayloadAction<PayloadGetSingleProductPricingType>
    ) => {
      return state
    },
    resetSelectedProductPricing: (state : ProductPricingState) => {
      state.selected = null;
    },
    createProductPricingAction: (state: ProductPricingState, _action) => {
      return state
    },
    updateProductPricingAction: (state: ProductPricingState, _action) => {
      return state
    },
    getProductPricingDataBySortAction: () => {
      return
    },
    getSelectedProductAction: (
      state: ProductPricingState,
      _action: PayloadAction<SelectedProductPayload>
    ) => {
      return state
    },
    updateSelectedAddProductsinProductPricing: (state, action) => {
      state.selectedProduct = action.payload
    },
    getAllProductPricingAction: () => {
      return
    },
    patchToggleUpdateActionProductPricing: (state: ProductPricingState, _action: PayloadAction<PatchProductPricingPayloadType>) => {
      return state;
    },
    patchToggleUpdateBulkActionProductPricing: (state: ProductPricingState, _action: PayloadAction<BulkPatchProductPricingPayloadType>) => {
      return state;
    },
	
  },
})

export const {
  getAllProductPricingByPageAction,
  updateProductPricingByPage,
  updateProductPricingData,
  getAllProductPricingAction,
  getSingleProductPricingAction,
  updateProductPricingAction,
  updateSelectedProductPricing,
  createProductPricingAction,
  getProductPricingDataBySortAction,
  getSelectedProductAction,
  updateSelectedAddProductsinProductPricing,
  patchToggleUpdateActionProductPricing,
  patchToggleUpdateBulkActionProductPricing,
  resetSelectedProductPricing,
} = ProductPricingSlice.actions
export default ProductPricingSlice.reducer
